<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    Mileage
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn
                    small
                    fab
                    :color="chk_chart == true ? 'lime accent-3' : 'amber'"
                    @click="chk_chart = !chk_chart"
                >
                    <v-icon>mdi-chart-line</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-if="chk_chart == true">
                <v-progress-linear
                    v-if="chk_data_graph == true"
                    indeterminate
                    color="orange accent-4"
                ></v-progress-linear>
                <AreaChart
                    style="height: 220px !important;"
                    :data_graph="data_graph"
                    v-if="data_graph.datasets && data_graph.datasets.length > 0"
                />
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-card class="mx-auto" max-width="400" color="blue lighten-3">
                    <v-list-item two-line>
                        <!-- <v-list-item-content> -->

                        <v-progress-linear
                            v-if="chk_data_sum == true"
                            color="orange accent-4"
                            indeterminate
                        ></v-progress-linear>

                        <v-list-item-title
                            class="headline "
                            v-if="chk_data_sum == false"
                        >
                            {{ data_sum.paycode }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                            <!-- <v-icon>mdi-cash-multiple</v-icon> -->
                            <b class="ml-1 color-3"
                                >{{ data_sum_all.sum_currency }} THB.</b
                            >
                        </v-list-item-subtitle>
                        <!-- </v-list-item-content> -->
                    </v-list-item>

                    <v-list class="transparent">
                        <v-list-item>
                            <v-list-item-title
                                >Avg. Case / CE</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                {{ data_sum_all.vol_job }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title
                                >Avg. Distance / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                {{ data_sum_all.distance }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title
                                >Avg. Cost / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                {{ data_sum_all.cost }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-progress-linear
                            v-if="chk_export === true"
                            indeterminate
                            color="orange accent-4"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_export === false"
                            text
                            class="btn-view-m-2"
                            @click="export_data()"
                        >
                            Export Data {{ data_sum.paycode }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-card class="mx-auto" max-width="400" color="blue lighten-3">
                    <v-list-item two-line>
                        <v-list-item-title class="headline color-3">
                            Top volume cases w/o return
                        </v-list-item-title>
                    </v-list-item>
                    <v-progress-linear
                        v-if="data_top_mileage.length == 0"
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>

                    <v-list class="transparent">
                        <v-list-item
                            v-for="(row_m, index_m) in data_top_mileage"
                            :key="index_m"
                        >
                            <v-list-item-title>
                                {{ index_m + 1 + ". " + row_m.ce_name }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ row_m.volume_job }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-progress-linear
                            v-if="chk_view_top1 == true"
                            indeterminate
                            color="orange accent-4"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_view_top1 == false"
                            text
                            class="btn-view-m-2"
                            @click="get_view_top('volume')"
                        >
                            View More
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
                <v-card class="mx-auto" max-width="400" color="blue lighten-3">
                    <v-list-item two-line>
                        <v-list-item-title class="headline color-3">
                            Top onsite distances w/o return (km)
                        </v-list-item-title>
                    </v-list-item>
                    <v-progress-linear
                        v-if="data_top_km.length == 0"
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>

                    <v-list class="transparent">
                        <v-list-item
                            v-for="(row_km, index_km) in data_top_km"
                            :key="index_km"
                        >
                            <v-list-item-title>
                                {{ index_km + 1 + ". " + row_km.ce_name }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ row_km.sum_km }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-progress-linear
                            v-if="chk_view_top2 == true"
                            indeterminate
                            color="orange accent-4"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_view_top2 == false"
                            text
                            class="btn-view-m-2"
                            @click="get_view_top('distance')"
                        >
                            View More
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="chk_data_sum == true">
            <v-col cols="12">
                <v-progress-linear
                    color="orange accent-4"
                    indeterminate
                ></v-progress-linear
            ></v-col>
        </v-row>

        <v-row v-if="chk_data_sum == false">
            <v-col
                cols="12"
                sm="6"
                md="4"
                v-for="(row, index) in data_sum['zone']"
                :key="index"
            >
                <!-- chk_data_sum -->
                <v-card
                    class="mx-auto"
                    max-width="400"
                    color="blue-grey darken-2"
                >
                    <v-list-item two-line>
                        <!-- <v-list-item-content> -->
                        <v-list-item-title class="headline color-1">
                            {{ row.tl_name }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-right ">
                            <!-- <v-icon 
                                    >mdi-cash-multiple</v-icon
                                > -->
                            <b class="ml-1 color-1"
                                >{{ row.sum_currency }} THB.</b
                            >
                        </v-list-item-subtitle>
                        <!-- </v-list-item-content> -->
                    </v-list-item>

                    <v-list class="transparent">
                        <v-list-item>
                            <v-list-item-title class="color-2"
                                >Avg. Case / CE</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                <span class="color-2">{{ row.vol_job }}</span>
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="color-2"
                                >Avg. Distance / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                <span class="color-2">{{ row.distance }}</span>
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="color-2"
                                >Avg. Cost / Case</v-list-item-title
                            >

                            <v-list-item-subtitle class="text-right">
                                <span class="color-2">{{ row.cost }}</span>
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-subtitle class="text-center">
                                <!-- <span class="subheading mr-2 fix-font-1ea">
                                    Total CE {{ row.total }}
                                </span>
                                <span class="mr-1 fix-font-ea">·</span>
                                <span class="subheading mr-2 fix-font-2ea">
                                    Pending {{ row.pending }}
                                </span>
                                <span class="mr-1 fix-font-ea">·</span>
                                <br />
                                <span class="subheading fix-font-3ea">
                                    Approved {{ row.approved }}
                                </span>
                                <span class="mr-1 fix-font-ea">·</span>
                                <span class="subheading fix-font-4ea">
                                    Reject {{ row.approved }}
                                </span> -->

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                        >
                                            <v-icon class="mr-1 fix-font-1ea">
                                                mdi-account-circle
                                            </v-icon>
                                            <span
                                                class="subheading  fix-font-1ea"
                                                >{{ row.total }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>All</span>
                                </v-tooltip>
                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                        >
                                            <v-icon class="mr-1 fix-font-2ea">
                                                mdi-alert-circle
                                            </v-icon>
                                            <span
                                                class="subheading  fix-font-2ea"
                                                >{{ row.pending }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Pending</span>
                                </v-tooltip>
                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                        >
                                            <v-icon class="mr-1 fix-font-4ea">
                                                mdi-close-circle
                                            </v-icon>
                                            <span
                                                class="subheading fix-font-4ea"
                                                >{{ row.reject }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Reject</span>
                                </v-tooltip>
                                <span class="ml-2 mr-2 fix-font-ea">·</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="cur-p2"
                                        >
                                            <v-icon class="mr-1 fix-font-3ea">
                                                mdi-checkbox-marked-circle
                                            </v-icon>
                                            <span
                                                class="subheading fix-font-3ea"
                                                >{{ row.approved }}</span
                                            >
                                        </span>
                                    </template>
                                    <span>Approved</span>
                                </v-tooltip>
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <router-link
                            class="link-a"
                            :to="'/Expense/Mileage/' + row.tl_id + '/all'"
                        >
                            <v-btn block text class="btn-view-m">
                                View Mileage
                            </v-btn>
                        </router-link>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialogViewTop"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogViewTop = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title
                            >View All Performance w/o return ( by
                            {{ form_top_view.type }} )</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ViewTop
                            :data_top="data_top"
                            :form_top_view="form_top_view"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

import ViewTop from "./components/ViewTopOnsite"

import AreaChart from "./components/AreaChart.vue"
import PieChart from "./components/PieChart.vue"
import BarChart from "./components/BarChart.vue"
import RadarChart from "./components/RadarChart.vue"
import LineChart from "./components/LineChart.vue"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        ViewTop,
        AreaChart,
        PieChart,
        BarChart,
        RadarChart,
        LineChart,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        this.role_name = localStorage.role_name
    },
    mounted() {
        this.chk_url()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async chk_url() {
            let send = {
                url: this.$route.path,
            }
            await axios
                .post(url + "check-auth", send, this.tk)
                .then((response) => {
                    if (response.data.status == "error") {
                        this.$root.$router.push({
                            path: "/404",
                        })
                    } else {
                        if (this.role_name === "TL") {
                            this.mileage_tl()
                        } else {
                            this.get_graph()
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_graph() {
            this.chk_data_graph = true
            this.chk_data_sum = true
            await axios
                .get(url + "mileage-cost-graph")
                .then((response) => {
                    this.data_graph = response.data
                    this.chk_data_graph = false
                    this.get_top_mileage()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_top_mileage() {
            await axios
                .get(url + "mileage-ce-graph")
                .then((response) => {
                    // console.log(response, "-data_top_mileage")
                    this.data_top_mileage = response.data
                    this.get_top_km()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_top_km() {
            await axios
                .get(url + "mileage-miles-graph/")
                .then((response) => {
                    this.data_top_km = response.data
                    this.get_data()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data() {
            await axios
                .get(url + "mileage-approve-summary", this.tk)
                .then((response) => {
                    this.chk_data_sum = false
                    this.data_sum = response.data
                    this.data_sum_all = response.data.all
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        formatToPrice(v) {
            return `${v.toFixed()}`
        },
        mileage_tl() {
            this.$root.$router.push({
                path: "/Expense/Mileage/Tl/all",
            })

            // this.mutateIsLoading()
            // await axios
            //     .get(url + "account-detail", this.tk)
            //     .then((response) => {
            //         this.mutateIsLoading()

            //     })
            //     .catch((error) => {
            //         this.mutateIsLoading()
            //         console.log(error)
            //     })
        },
        async export_data() {
            this.chk_export = true
            await axios({
                url: url + "mileage-export",
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                this.chk_export = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async get_view_top(ty) {
            ty == "volume"
                ? (this.chk_view_top1 = true)
                : (this.chk_view_top2 = true)
            this.form_top_view.type = ty
            await axios
                .post(url + "mileage-graph-all", this.form_top_view, {})
                .then((response) => {
                    this.data_top = response.data
                    this.chk_view_top1 = false
                    this.chk_view_top2 = false
                    this.dialogViewTop = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data: () => ({
        chk_export: false,
        duration_time: 2500,
        chk_data_graph: false,
        data_graph: [],
        data_top_mileage: [],
        data_top_km: [],
        data_sum: [],
        data_sum_all: [],
        chk_data_sum: false,
        colorFix: "teal lighten-3",
        colorFix_1: "blue lighten-4",
        role_name: null,
        chartData: {
            Books: 24,
            Magazine: 30,
            Newspapers: 10,
        },
        chk_view_top1: false,
        chk_view_top2: false,
        data_top: [],
        dialogViewTop: false,
        form_top_view: {
            type: "",
            tl_id: "",
        },
        chk_chart: false,
    }),
}
</script>
<style scoped>
.btn-view-m {
    color: #c8eeca;
}
.btn-view-m:hover {
    color: #00ff3b;
    background-color: #5a7088;
}
.btn-view-m-2 {
    color: #01152c;
}
.btn-view-m-2:hover {
    color: #9ac6f0;
    background-color: #326586;
}
.color-3 {
    color: #01152c;
}
.color-1 {
    color: #00ff3b;
}
.color-2 {
    color: #fff;
}
.fix-font-ea {
    color: #fff;
    font-weight: bold;
}
.fix-font-1ea {
    color: #a1ecd6;
    font-weight: bold;
}
.fix-font-2ea {
    color: #fae06c;
    font-weight: bold;
}
.fix-font-3ea {
    color: #00ff3b;
    font-weight: bold;
}
.fix-font-4ea {
    color: #ff6262;
    font-weight: bold;
}
</style>
